<template>
	<basic-skeleton-loader v-if="!articles" />

	<base-container v-else-if="typeof articles === 'object' && articles.length === 0">
		<p>No content was found for this page</p>
	</base-container>

	<template v-else>
		<base-container class="flex flex-wrap items-center justify-between py-4 !mb-4 gap-y-2 md:gap-y-0" v-if="page?.meta?.issue">
			<div>
				<h1 class="mb-0 text-xl font-semibold text-gray-700">{{ page.meta.issue }}</h1>
				<h2 class="mt-0 text-gray-600 text-md">{{ page.meta?.subtitle }}</h2>
			</div>
			<a v-if="page?.meta?.table_of_contents" :href="page.meta.table_of_contents" target="_blank" class="rounded-md transition-all bg-gray-500 hover:bg-gray-700 text-white font-medium py-1.5 px-5 text-sm w-fit self-start">Table of Contents</a>
		</base-container>

		<base-container v-for="article in articles" :key="article.id" class="!mb-4">
			<component :is="contentType(article.type)" :article="article" />
		</base-container>
	</template>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { useApi } from '@/composables/useApi'
import { contentTypes } from '@/config/componentMap'
import BaseContainer from '@/components/layout/base/BaseContainer.vue'
import BasicSkeletonLoader from '@/components/layout/skeleton/BasicSkeletonLoader.vue'

const props = defineProps({
  page: {
    type: Object,
    required: true
  }
})

const route = useRoute()

const { api } = useApi()

const articles = ref(null)

function contentType(type) {
  return contentTypes[type]
}

// if path matches the agreed-upon pattern to get all articles containing a live video reference for the provided year, i.e. /live/2025-live-contents
if (/^\/ch-live\/\d{4}-live-contents$/.test(route.fullPath)) {
  // extract year from the path
  const year = route.fullPath.match(/\d{4}/g)?.[0] ?? null

  // call api endpoint that gets all articles containing a live video reference for the provided year
  api({
    url: `/content/live/${year}`,
    callback: data => {
      articles.value = data
    },
    errorCallback: () => {
      articles.value = null
      console.error('Error when requesting content')
    }
  })
} else { // default content handling
  api({
    url: `/content/${props.page.id}`,
    callback: data => {
      articles.value = data
    },
    errorCallback: () => {
      articles.value = null
      console.error('Error when requesting content')
    }
  })
}
</script>
